module.exports = __webpack_public_path__ + "static/media/Apple MacBook Air 13\" Gold.25f05576.png";